import { checkAndGetInvitationStatus } from "../../screens/my-projects/utils";

export function getUpdatedProjectInvitationList(data) {
  return data?.map((d) => {
    return {
      ...d,
      status: checkAndGetInvitationStatus(d),
    };
  });
}
